import * as RadixTooltip from '@radix-ui/react-tooltip';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router/dom';
import { ToastContainer } from 'react-toastify';

import { PATHS } from '@/shared/config';
import '@/shared/graphics/debugToolForPreview.ts';
import { MIRenderOrchestrator } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import { ForcedLogoutNotice } from '@/features/logout';

import { KbVideoHost } from '@/widgets/KnowledgeBase';
import { RefreshPage } from '@/widgets/RefreshPage';
import { SupportFallback } from '@/widgets/SupportFallback/index.ts';

import { ErrorPage } from '@/pages/ErrorPage/ErrorPage';

import { setupAnalytics } from './model/initAnalytics';
import { initSessionEndRedirect } from './model/initSessionEndRedirect';
import { router } from './model/router';
import { actions, store } from './model/store';
import { IntlProvider } from './providers/IntlProvider';
import { ThemeProvider } from './providers/ThemeProvider.tsx';

type MIRenderOrchestratorActions = Parameters<
  typeof MIRenderOrchestrator.orchestrate
>[0]['actions'];

// TODO: [4|h] Integrate tracker after update react router to the last version.
// import { HubspotEventsTracker } from './utils/HubspotEventTracker';
// TODO: Update MedicalImageRender library to align with proto V2 types
// (MedicalImageViewOptions_Legacy → MedicalImageViewOptions migration)
MIRenderOrchestrator.orchestrate({
  PATHS,
  store,
  actions: actions as unknown as MIRenderOrchestratorActions,
});

setupAnalytics();
initSessionEndRedirect();

export const App = Sentry.withProfiler(() => (
  <Provider store={store}>
    <ThemeProvider>
      <IntlProvider>
        <RadixTooltip.Provider skipDelayDuration={0}>
          <Sentry.ErrorBoundary fallback={<ErrorPage />}>
            <RouterProvider router={router} />
            <RefreshPage />
            <SupportFallback />
            <ToastContainer icon={false} hideProgressBar />
            <ForcedLogoutNotice />
            {/* The knowledge base video lives at the root, so closing the
                panel or changing pages cannot stop it. */}
            <KbVideoHost />
          </Sentry.ErrorBoundary>
        </RadixTooltip.Provider>
      </IntlProvider>
    </ThemeProvider>
  </Provider>
));
